var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAgendado(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 168,
    height: 77,
    viewBox: "0 0 168 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.5 4C164.366 4 167.5 7.134 167.5 11C167.5 14.866 164.366 18 160.5 18H120.5C124.366 18 127.5 21.134 127.5 25C127.5 28.866 124.366 32 120.5 32H142.5C146.366 32 149.5 35.134 149.5 39C149.5 42.866 146.366 46 142.5 46H132.326C127.452 46 123.5 49.134 123.5 53C123.5 55.5773 125.5 57.9107 129.5 60C133.366 60 136.5 63.134 136.5 67C136.5 70.866 133.366 74 129.5 74H46.5C42.634 74 39.5 70.866 39.5 67C39.5 63.134 42.634 60 46.5 60H7.5C3.634 60 0.5 56.866 0.5 53C0.5 49.134 3.634 46 7.5 46H47.5C51.366 46 54.5 42.866 54.5 39C54.5 35.134 51.366 32 47.5 32H22.5C18.634 32 15.5 28.866 15.5 25C15.5 21.134 18.634 18 22.5 18H62.5C58.634 18 55.5 14.866 55.5 11C55.5 7.134 58.634 4 62.5 4H160.5ZM160.5 32C164.366 32 167.5 35.134 167.5 39C167.5 42.866 164.366 46 160.5 46C156.634 46 153.5 42.866 153.5 39C153.5 35.134 156.634 32 160.5 32Z",
    fill: "#FBBA3E",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M112.875 32.0834H55.125M112.875 40.1042V28.2334C112.875 22.8429 112.875 20.1477 111.826 18.0888C110.903 16.2777 109.431 14.8053 107.62 13.8825C105.561 12.8334 102.866 12.8334 97.475 12.8334H70.525C65.1345 12.8334 62.4392 12.8334 60.3803 13.8825C58.5693 14.8053 57.0968 16.2777 56.1741 18.0888C55.125 20.1477 55.125 22.8429 55.125 28.2334V55.1834C55.125 60.5739 55.125 63.2692 56.1741 65.3281C57.0968 67.1391 58.5693 68.6116 60.3803 69.5344C62.4392 70.5834 65.1345 70.5834 70.525 70.5834H84M96.8333 6.41675V19.2501M71.1667 6.41675V19.2501M92.0208 60.9584L98.4375 67.3751L112.875 52.9376",
    stroke: "#FBBA3E",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgendado);
export default __webpack_public_path__ + "static/media/agendado.8cc360cec516cb36291f55801eb2f5cc.svg";
export { ForwardRef as ReactComponent };